import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card, LanguageSwitcher, Logo } from '@core/ui';

/**
 * Centered card layout for authentication pages (login only for now — there is
 * no self-service signup; accounts are created in the Django admin).
 */
export function AuthLayout() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col bg-[var(--color-bg-subtle)]">
      <main className="flex-1 flex items-center justify-center px-4 py-8 pt-[max(2rem,env(safe-area-inset-top))] sm:py-12">
        <div className="w-full max-w-md">
          <div className="flex justify-center mb-6">
            <Logo className="h-9 w-auto" />
          </div>
          <Card className="shadow-sm p-6 sm:p-8">
            <Outlet />
          </Card>
        </div>
      </main>
      {/* --color-text-secondary, not -muted: this sits on --color-bg-subtle, where
          muted is 4.33:1 and fails AA (see docs/features/design-system.md). */}
      <footer className="flex flex-col items-center gap-y-3 px-4 py-6 text-center text-xs text-[var(--color-text-secondary)]">
        <LanguageSwitcher />
        <p>{t('footer.copyright', { year: new Date().getFullYear() })}</p>
      </footer>
    </div>
  );
}
